import { appConfig } from '@/config'

export default {
    computed: {
        hasImpositionPrintTask() {
            return this.imposition.impositionTask.some(task => task.processId === appConfig.common.processes.printTaskId)
        },
        printMachineSheetRequirements() {
            const printTask = this.task.processId === appConfig.common.processes.printTaskId ?
                this.task :
                this.imposition.impositionTask.find(task => {
                    return task.processId === appConfig.common.processes.printTaskId
                })

            return {
                minSheetWidth: printTask ? printTask.machine.minSheetWidth : 0,
                maxSheetWidth: printTask ? printTask.machine.maxSheetWidth : 0,
                minSheetHeight: printTask ? printTask.machine.minSheetHeight : 0,
                maxSheetHeight: printTask ? printTask.machine.maxSheetHeight : 0,
            }
        },

        formatRangeValidations() {
            return {
                formatARangeX: this.imposition.formatA >= this.printMachineSheetRequirements.minSheetWidth && this.imposition.formatA <= this.printMachineSheetRequirements.maxSheetWidth,
                formatARangeY: this.imposition.formatA >= this.printMachineSheetRequirements.minSheetHeight && this.imposition.formatA <= this.printMachineSheetRequirements.maxSheetHeight,
                formatBRangeX: this.imposition.formatB >= this.printMachineSheetRequirements.minSheetWidth && this.imposition.formatB <= this.printMachineSheetRequirements.maxSheetWidth,
                formatBRangeY: this.imposition.formatB >= this.printMachineSheetRequirements.minSheetHeight && this.imposition.formatB <= this.printMachineSheetRequirements.maxSheetHeight
            }
        }
    },
    methods: {
        handleFormatA(value) {
            this.imposition.formatA = +value
        },
        handleFormatB(value) {
            this.imposition.formatB = +value
        },
        changeFormatA(value) {
            this.imposition.formatA = +value || 0
        },
        changeFormatB(value) {
            this.imposition.formatB = +value || 0
        },
        impositionFormatHint() {
            if (!this.isJobEditable || !this.hasImpositionPrintTask) return

            return `Dopuszczalny zakres ${this.printMachineSheetRequirements.minSheetWidth}-${this.printMachineSheetRequirements.maxSheetWidth} lub ${this.printMachineSheetRequirements.minSheetHeight}-${this.printMachineSheetRequirements.maxSheetHeight}`
        },
    }
}